import hasClass from './hasClass';
function removeClass(element, classRemoveStr) {
  const reg = new RegExp("(\\s|^)".concat(classRemoveStr, "(\\s|$)"));
  if (hasClass(element, classRemoveStr)) {
    element.className = element.className.replace(reg, ' ').trim();
  }
}
export default removeClass;